import React, { useState } from "react";

interface DelegationFileUploadProps {
  formData: {
    attachedFiles: File[];
  };
  handleInputChange: (field: string, value: any) => void;
}

const DelegationFileUpload: React.FC<DelegationFileUploadProps> = ({
  formData,
  handleInputChange,
}) => {
  const handleFileSelect = (files: FileList | null) => {
    if (files) {
      const newFiles = Array.from(files);
      handleInputChange("attachedFiles", [
        ...formData.attachedFiles,
        ...newFiles,
      ]);
    }
  };

  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      {/* File Upload Section */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          File đính kèm (Bạn có thể chọn nhiều file một lần!)
        </label>

        {/* Simple File Input */}
        <div className="flex items-center space-x-4">
          <input
            type="file"
            multiple
            onChange={(e) => handleFileSelect(e.target.files)}
            className="hidden"
            id="file-upload"
          />
          <label
            htmlFor="file-upload"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 cursor-pointer transition-colors"
          >
            Choose Files
          </label>
          <span className="text-sm text-gray-500">
            {formData.attachedFiles.length === 0
              ? "No file chosen"
              : `${formData.attachedFiles.length} file(s) chosen`}
          </span>
        </div>

        {/* File List */}
        {formData.attachedFiles.length > 0 && (
          <div className="mt-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Files:</h4>
            <div
              className={`space-y-2 ${
                formData.attachedFiles.length > 3
                  ? "max-h-48 overflow-y-auto pr-2"
                  : ""
              }`}
            >
              {formData.attachedFiles.map((file, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-2 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center space-x-2 min-w-0 flex-1">
                    <svg
                      className="w-4 h-4 text-gray-400 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    <div className="min-w-0 flex-1">
                      <div className="text-sm font-medium text-gray-900 truncate">
                        {file.name}
                      </div>
                      <div className="text-xs text-gray-500">
                        {(file.size / 1024).toFixed(1)} KB
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      const updatedFiles = formData.attachedFiles.filter(
                        (_, i) => i !== index
                      );
                      handleInputChange("attachedFiles", updatedFiles);
                    }}
                    className="text-red-500 hover:text-red-700 hover:bg-red-50 p-1 rounded transition-colors flex-shrink-0"
                    title="Xóa file"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DelegationFileUpload;
